/* Ann Michael Collective — Theme JS */
(function () {
  'use strict';

  // ==================== HERO ROTATOR ====================
  // Cycles through hero slides: video plays first (longer), then images cross-fade.
  // Pauses on user interaction with dots; resumes after a beat.
  document.querySelectorAll('[data-hero-rotator]').forEach(rotator => {
    const slides = rotator.querySelectorAll('.hero-slide');
    if (slides.length < 2) return;
    const dots = rotator.querySelectorAll('.hero-rotator__dot');
    const videoSlideIdx = Array.from(slides).findIndex(s => s.querySelector('.hero__video'));
    let current = 0;
    let timer = null;

    function durationFor(idx) {
      const isVideo = idx === videoSlideIdx;
      // Pull values from data-attribs, fallback to defaults
      const rootEl = document.documentElement;
      const videoSec = parseInt(rotator.dataset.videoSec || '14', 10);
      const imageSec = parseInt(rotator.dataset.imageSec || '7', 10);
      return (isVideo ? videoSec : imageSec) * 1000;
    }

    function go(idx) {
      slides.forEach(s => s.classList.remove('is-active'));
      slides[idx].classList.add('is-active');
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      current = idx;
      // Restart video each time it shows
      const video = slides[idx].querySelector('video');
      if (video) { try { video.currentTime = 0; video.play(); } catch (e) {} }
      schedule();
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(() => go((current + 1) % slides.length), durationFor(current));
    }

    dots.forEach((d, i) => {
      d.addEventListener('click', e => {
        e.preventDefault();
        go(i);
      });
    });

    // Pause when user hovers over the section (desktop only)
    rotator.addEventListener('mouseenter', () => clearTimeout(timer));
    rotator.addEventListener('mouseleave', schedule);

    schedule();
  });

  // ==================== MEGA MENU ====================
  document.querySelectorAll('[data-mega-trigger]').forEach(item => {
    const btn = item.querySelector('.nav-link--has-mega');
    if (!btn) return;
    // Toggle on click (touch + accessibility)
    btn.addEventListener('click', e => {
      e.preventDefault();
      const isOpen = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen);
      // Close any others
      document.querySelectorAll('[data-mega-trigger]').forEach(other => {
        if (other !== item) {
          other.classList.remove('is-open');
          other.querySelector('.nav-link--has-mega')?.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });
  // Close mega-menu on outside click
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-mega-trigger]')) {
      document.querySelectorAll('[data-mega-trigger].is-open').forEach(item => {
        item.classList.remove('is-open');
        item.querySelector('.nav-link--has-mega')?.setAttribute('aria-expanded', 'false');
      });
    }
  });
  // Close on Esc
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-mega-trigger].is-open').forEach(item => {
        item.classList.remove('is-open');
        item.querySelector('.nav-link--has-mega')?.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // ==================== MOBILE NAV ====================
  const menuToggle = document.getElementById('MenuToggle');
  const mobileNav = document.getElementById('MobileNav');
  const mobileNavClose = document.getElementById('MobileNavClose');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => mobileNav.classList.add('is-open'));
  }
  if (mobileNavClose && mobileNav) {
    mobileNavClose.addEventListener('click', () => mobileNav.classList.remove('is-open'));
  }
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mobileNav.classList.remove('is-open')));
  }

  // ==================== CART DRAWER ====================
  const cartToggle = document.getElementById('CartToggle');
  const cartDrawer = document.getElementById('CartDrawer');
  const cartOverlay = document.getElementById('CartOverlay');
  const cartDrawerClose = document.getElementById('CartDrawerClose');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartToggle) {
    cartToggle.addEventListener('click', e => { e.preventDefault(); openCart(); });
  }
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  async function refreshCart() {
    /* === A1 cart drawer fragment === */
    try {
      const [cartResp, drawerResp] = await Promise.all([
        fetch('/cart.js'),
        fetch('/?section_id=cart-drawer-fragment')
      ]);
      const cart = await cartResp.json();
      const drawerHtml = await drawerResp.text();
      document.querySelectorAll('#CartCount, #CartDrawerCount').forEach(el => {
        el.textContent = cart.item_count;
        el.dataset.empty = cart.item_count === 0 ? 'true' : 'false';
      });
      const tmp = document.createElement('div');
      tmp.innerHTML = drawerHtml;
      const newBody = tmp.querySelector('#CartDrawerBody');
      const newFooter = tmp.querySelector('.cart-drawer__footer');
      const oldBody = document.getElementById('CartDrawerBody');
      const oldFooter = document.querySelector('.cart-drawer__footer');
      if (newBody && oldBody) oldBody.replaceWith(newBody);
      if (newFooter && oldFooter) oldFooter.replaceWith(newFooter);
      else if (newFooter && !oldFooter) document.querySelector('.cart-drawer')?.appendChild(newFooter);
    } catch (e) {
      console.error('refreshCart', e);
      window.location.reload();
    }
  }

  // Drawer button delegation (qty +/-, remove)
  function bindDrawerEvents() {
    if (!cartDrawer) return;
    // Re-bind close button after innerHTML replace
    const closeBtn = cartDrawer.querySelector('#CartDrawerClose');
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    cartDrawer.querySelectorAll('[data-action]').forEach(btn => {
      btn.addEventListener('click', async e => {
        e.preventDefault();
        const action = btn.dataset.action;
        const line = parseInt(btn.dataset.line, 10);
        const qtyEl = btn.parentElement.querySelector('span');
        const currentQty = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
        const newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
        btn.disabled = true;
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({ line, quantity: newQty })
          });
          await refreshCart({ skipReloadIfOnCart: true });
        } catch (err) { console.error(err); btn.disabled = false; }
      });
    });
    cartDrawer.querySelectorAll('.cart-line__remove').forEach(link => {
      link.addEventListener('click', async e => {
        e.preventDefault();
        const line = parseInt(link.dataset.line, 10);
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({ line, quantity: 0 })
          });
          await refreshCart({ skipReloadIfOnCart: true });
        } catch (err) { console.error(err); }
      });
    });
  }
  bindDrawerEvents();

  // ==================== ADD TO CART (PDP) ====================
  const productForm = document.getElementById('ProductForm');
  const qtyDown = document.getElementById('QtyDown');
  const qtyUp = document.getElementById('QtyUp');
  const qtyInput = document.getElementById('QtyInput');

  if (qtyDown && qtyInput) qtyDown.addEventListener('click', () => { qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1); });
  if (qtyUp && qtyInput) qtyUp.addEventListener('click', () => { qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1; });

  if (productForm) {
    productForm.addEventListener('submit', async e => {
      e.preventDefault();
      const fd = new FormData(productForm);
      const btn = document.getElementById('AddToCartBtn');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
      try {
        const resp = await fetch('/cart/add.js', { method: 'POST', body: fd });
        if (!resp.ok) throw new Error('add to cart failed');
        await resp.json();
        openCart();
        await refreshCart();
      } catch (err) {
        if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
        alert('Could not add to cart. Try again.');
      }
    });
  }

  // ==================== VARIANT PICKER ====================
  const productJsonEl = document.querySelector('script[data-product-json]');
  if (productJsonEl) {
    let productData;
    try { productData = JSON.parse(productJsonEl.textContent); } catch(e) {}

    if (productData) {
      const optionGroups = document.querySelectorAll('.variant-group');
      const selectedVariantInput = document.getElementById('ProductSelectedVariant');
      const addBtn = document.getElementById('AddToCartBtn');

      function getSelectedOptions() {
        return Array.from(optionGroups).map(g => {
          const active = g.querySelector('.variant-option.is-active, .swatch.is-active');
          return active ? active.dataset.optionValue : null;
        });
      }

      function findVariant(opts) {
        return productData.variants.find(v => {
          return opts.every((opt, i) => v.options[i] === opt);
        });
      }

      function updatePriceBlock(variant) {
        const block = document.getElementById('ProductPriceBlock');
        if (!block || !variant) return;
        const priceEl = block.querySelector('.product__price');
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        const compareEl = block.querySelector('.product__price--compare');
        const saleTag = block.querySelector('.product__price--sale-tag');
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
          if (saleTag) { saleTag.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price); saleTag.style.display = ''; }
        } else {
          if (compareEl) compareEl.style.display = 'none';
          if (saleTag) saleTag.style.display = 'none';
        }
      }

      function updateAddBtn(variant) {
        if (!addBtn) return;
        if (!variant || !variant.available) {
          addBtn.disabled = true;
          addBtn.textContent = variant ? 'Sold out' : 'Unavailable';
        } else {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to cart — ' + formatMoney(variant.price);
        }
      }

      // Treat both .variant-option and .swatch the same way
      function selectOptionValue(group, value) {
        group.querySelectorAll('.variant-option, .swatch').forEach(o => o.classList.remove('is-active'));
        const target = group.querySelector(`.variant-option[data-option-value="${CSS.escape(value)}"], .swatch[data-option-value="${CSS.escape(value)}"]`);
        if (target) target.classList.add('is-active');
        const sel = group.querySelector('.variant-select');
        if (sel && sel.value !== value) sel.value = value;
        const labelEl = group.querySelector('.variant-group__selected');
        if (labelEl) labelEl.textContent = value;
        const opts = getSelectedOptions();
        const variant = findVariant(opts);
        if (variant) {
          selectedVariantInput.value = variant.id;
          updateAddBtn(variant);
          updatePriceBlock(variant);
          // Swap main image
          const mainImg = document.getElementById('ProductMainImg');
          const variantImgUrl = variant.featured_image && (variant.featured_image.src || variant.featured_image);
          if (mainImg && variantImgUrl) {
            const fullUrl = variantImgUrl.startsWith('//') ? 'https:' + variantImgUrl : variantImgUrl;
            const baseUrl = fullUrl.replace(/[?&]width=\d+/, '');
            const sized = baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'width=1200';
            mainImg.classList.add('is-swapping');
            mainImg.src = sized;
            mainImg.removeAttribute('srcset');
            if (mainImg.dataset) mainImg.dataset.zoomSrc = baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'width=2400';
            requestAnimationFrame(() => requestAnimationFrame(() => mainImg.classList.remove('is-swapping')));
            document.querySelectorAll('.product__thumb').forEach(t => {
              const thumbUrl = (t.dataset.img || '').replace(/[?&]width=\d+/, '');
              if (baseUrl && thumbUrl && thumbUrl.split('?')[0] === baseUrl.split('?')[0]) {
                document.querySelectorAll('.product__thumb').forEach(o => o.classList.remove('is-active'));
                t.classList.add('is-active');
              }
            });
          }
        }
      }

      // Wire dropdowns
      document.querySelectorAll('.variant-select').forEach(sel => {
        sel.addEventListener('change', () => {
          const group = sel.closest('.variant-group, .variant-group--swatches');
          if (group) selectOptionValue(group, sel.value);
        });
      });
      // Wire swatch clicks
      document.querySelectorAll('.swatch').forEach(sw => {
        sw.addEventListener('click', () => {
          const group = sw.closest('.variant-group, .variant-group--swatches');
          if (group) selectOptionValue(group, sw.dataset.optionValue);
        });
      });

      optionGroups.forEach(group => {
        group.querySelectorAll('.variant-option').forEach(opt => {
          opt.addEventListener('click', () => {
            group.querySelectorAll('.variant-option').forEach(o => o.classList.remove('is-active'));
            opt.classList.add('is-active');
            const opts = getSelectedOptions();
            const variant = findVariant(opts);
            if (variant) {
              selectedVariantInput.value = variant.id;
              updateAddBtn(variant);
              // Swap main image + matching thumb to this variant's featured image
              const mainImg = document.getElementById('ProductMainImg');
              const variantImgUrl = variant.featured_image && (variant.featured_image.src || variant.featured_image);
              if (mainImg && variantImgUrl) {
                // Normalize protocol-relative URLs
                const fullUrl = variantImgUrl.startsWith('//') ? 'https:' + variantImgUrl : variantImgUrl;
                // Strip any width param so we can request the size we want
                const baseUrl = fullUrl.replace(/[?&]width=\d+/, '');
                const sized = baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'width=1200';
                mainImg.classList.add('is-swapping');
                mainImg.src = sized;
                mainImg.removeAttribute('srcset');
                if (mainImg.dataset) mainImg.dataset.zoomSrc = baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'width=2400';
                requestAnimationFrame(() => requestAnimationFrame(() => mainImg.classList.remove('is-swapping')));
                // Sync thumb active state
                document.querySelectorAll('.product__thumb').forEach(t => {
                  const thumbUrl = (t.dataset.img || '').replace(/[?&]width=\d+/, '');
                  if (baseUrl && thumbUrl && thumbUrl.split('?')[0] === baseUrl.split('?')[0]) {
                    document.querySelectorAll('.product__thumb').forEach(o => o.classList.remove('is-active'));
                    t.classList.add('is-active');
                  }
                });
              }
            }
          });
        });
      });
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ==================== PDP THUMBNAIL SWAPPER ====================
  const mainImg = document.getElementById('ProductMainImg');
  const mainZoomTrigger = document.getElementById('ProductMainZoom');
  // Use event delegation so it works regardless of DOM timing.
  document.addEventListener('click', e => {
    const thumb = e.target.closest('.product__thumb');
    if (!thumb || !mainImg) return;
    e.preventDefault();
    document.querySelectorAll('.product__thumb').forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
    const url = thumb.dataset.img;
    if (url) {
      mainImg.classList.add('is-swapping');
      mainImg.src = url;
      // Match large srcset to the new src so high-res variants don't fight it
      mainImg.removeAttribute('srcset');
      requestAnimationFrame(() => requestAnimationFrame(() => mainImg.classList.remove('is-swapping')));
    }
    const zoomUrl = thumb.dataset.zoom || url;
    if (zoomUrl) mainImg.dataset.zoomSrc = zoomUrl;
  });

  // ==================== PDP LIGHTBOX ====================
  const lightbox = document.getElementById('ProductLightbox');
  const lightboxImg = document.getElementById('ProductLightboxImg');
  const lightboxClose = document.getElementById('ProductLightboxClose');
  const lightboxPrev = document.getElementById('ProductLightboxPrev');
  const lightboxNext = document.getElementById('ProductLightboxNext');

  function getZoomUrls() {
    const thumbs = document.querySelectorAll('.product__thumb');
    if (thumbs.length) {
      return Array.from(thumbs).map(t => t.dataset.zoom || t.dataset.img);
    }
    if (mainImg) return [mainImg.dataset.zoomSrc || mainImg.src];
    return [];
  }

  function openLightbox(startIndex) {
    if (!lightbox || !lightboxImg) return;
    const urls = getZoomUrls();
    if (!urls.length) return;
    lightbox.dataset.index = String(startIndex);
    lightbox.dataset.total = String(urls.length);
    lightboxImg.src = urls[startIndex] || urls[0];
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function stepLightbox(delta) {
    if (!lightbox) return;
    const urls = getZoomUrls();
    if (!urls.length) return;
    const cur = parseInt(lightbox.dataset.index || '0', 10);
    const next = (cur + delta + urls.length) % urls.length;
    lightbox.dataset.index = String(next);
    lightboxImg.src = urls[next];
    // Sync the active thumb + main image so closing matches the last viewed slide
    const thumbs = document.querySelectorAll('.product__thumb');
    if (thumbs[next]) thumbs[next].click();
  }

  if (mainZoomTrigger) {
    mainZoomTrigger.addEventListener('click', () => {
      const thumbs = document.querySelectorAll('.product__thumb');
      const activeIdx = Array.from(thumbs).findIndex(t => t.classList.contains('is-active'));
      openLightbox(Math.max(0, activeIdx));
    });
  }
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightbox) {
    lightbox.addEventListener('click', e => { if (e.target === lightbox) closeLightbox(); });
  }
  if (lightboxPrev) lightboxPrev.addEventListener('click', e => { e.stopPropagation(); stepLightbox(-1); });
  if (lightboxNext) lightboxNext.addEventListener('click', e => { e.stopPropagation(); stepLightbox(1); });
  document.addEventListener('keydown', e => {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') stepLightbox(-1);
    if (e.key === 'ArrowRight') stepLightbox(1);
  });
})();
